import React from "react";

type RowSkeletonGroupProps = {
  numRows?: number;
  columns?: string[];
  showAction?: boolean;
};

const DEFAULT_COLUMNS = ["name", "number", "currency", "status"];

const SkeletonRow = ({ columns, showAction }: { columns: string[]; showAction: boolean }) => (
  <div className="row-skeleton" data-cy="row-skeleton">
    {columns.map((col, i) => (
      <span key={i} className={`row-skeleton__bar row-skeleton__bar--${col}`} />
    ))}
    <div className="row-skeleton__action-col">
      {showAction && <span className="row-skeleton__pill" />}
    </div>
  </div>
);

const RowSkeletonGroup = ({
  numRows = 5,
  columns = DEFAULT_COLUMNS,
  showAction = true,
}: RowSkeletonGroupProps) => {
  const rows: React.ReactElement[] = [];
  for (let i = 0; i < numRows; i++) {
    rows.push(<SkeletonRow key={i} columns={columns} showAction={showAction} />);
  }
  return (
    <div
      className="row-skeleton-group"
      data-cy="row-skeleton-group"
      data-testid="row-skeleton-group"
      style={{ "--skeleton-cols": columns.length } as React.CSSProperties}
    >
      {rows}
    </div>
  );
};

export default RowSkeletonGroup;